import axios from "axios";

const api = axios.create({
  baseURL: (import.meta.env as any).VITE_API_URL ?? "/api",
  withCredentials: true,
});

// Attach JWT from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ssn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Smart-routing on 401 response & connectivity failure logging
api.interceptors.response.use(
  (r) => r,
  (err) => {
    // 1. Log network connectivity/CORS/Server down failures
    if (!err.response) {
      console.error("API CONNECTIVITY FAILURE DETECTED:");
      console.error(`Target URL: ${err.config?.baseURL}${err.config?.url}`);
      console.error("Error Message:", err.message);

      if (err.request) {
        console.warn("The request was made but no response was received. This usually means a CORS issue, a bad backend URL, or the server is down.");
      } else {
        console.warn("Request configuration error:", err.message);
      }
    } else {
      // 2. Log actual HTTP error responses (4xx, 5xx) to help debugging
      console.error(`API Error Response (${err.response.status}):`, err.response.data);
    }

    // Existing 401 Authentication handler
    if (err.response?.status === 401) {
      // Clear the invalid credentials from storage safely
      localStorage.removeItem("ssn_token");
      localStorage.removeItem("ssn_user");

      // Only redirect to login if the user is attempting to look at a secured path
      if (window.location.pathname.startsWith("/dashboard")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;